import { randomTransactionId } from "redsys-easy";
import { mapMutations } from "vuex";
/// <reference path="./node_modules/@types/googlepay/index.d.ts" />

let alreadyInitialized = false;
// an initialized google.payments.api.PaymentsClient object or null if not yet set
let paymentsClient = null;
//  Define the version of the Google Pay API referenced when creating your
const baseRequest = {
  apiVersion: 2,
  apiVersionMinor: 0
};
// Describe your site's support for the CARD payment method including optional
const allowedPaymentMethods = [
  {
    // Describe your site's support for the CARD payment method and its required
    type: "CARD",
    parameters: {
      // Card authentication methods supported by your site and your gateway
      allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
      // Card networks supported by your site and your gateway
      allowedCardNetworks: [
        "AMEX",
        "DISCOVER",
        "INTERAC",
        "JCB",
        "MASTERCARD",
        "VISA"
      ]
    },
    // Identify your gateway and your site's gateway merchant identifier
    tokenizationSpecification: {
      type: "PAYMENT_GATEWAY",
      parameters: {
        gateway: "redsys",
        gatewayMerchantId: process.env.VUE_APP_REDSYS_MERCHANT_CODE
      }
    }
  }
];

const googlePayReadyDeffer = { resolve: null, reject: null };

const googlePayReadyPromise = new Promise((resolve, reject) => {
  googlePayReadyDeffer.resolve = resolve;
  googlePayReadyDeffer.reject = reject;
});

function loadGooglePay(onPaymentAuthorizedFn) {
  if (alreadyInitialized) {
    return;
  }
  alreadyInitialized = true;
  const s = document.createElement("script");
  s.async = true;
  s.setAttribute("src", "https://pay.google.com/gp/p/js/pay.js");
  s.onload = () => {
    // eslint-disable-next-line no-undef
    paymentsClient = new google.payments.api.PaymentsClient({
      environment: process.env.VUE_APP_GOOGLEPAY_ENVIRONMENT,
      paymentDataCallbacks: {
        onPaymentAuthorized: paymentData => {
          console.log(
            "google.pay.paymentDataCallbacks.onPaymentAuthorized",
            paymentData
          );
          return onPaymentAuthorizedFn(paymentData);
        }
      }
    });
    paymentsClient
      .isReadyToPay({
        ...baseRequest,
        allowedPaymentMethods
      })
      .then(response => {
        googlePayReadyDeffer.resolve(response);
        console.log("google.pay.isReadyToPay", response);
      })
      .catch(e => {
        googlePayReadyDeffer.resolve({ error: e });
        console.error("google.pay.isReadyToPay", e);
      });
  };
  s.onerror = e => {
    googlePayReadyDeffer.resolve({ error: e });
  };
  document.body.appendChild(s);
}

export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setCurrentPaymentMethod: "redsys/SET_CURRENT_PAYMENT_METHOD"
    }),
    loadGogglePay() {
      loadGooglePay(this.onPaymentAuthorized.bind(this));
    },
    onGooglePayLoaded() {
      googlePayReadyPromise.then(res => {
        if (res.error) {
          alert("¡Algo salió mal! Google Pay no disponible");
          return;
        }

        const button = paymentsClient.createButton({
          onClick: this.onGooglePaymentButtonClicked,
          buttonType: "short",
          buttonSizeMode: "fill"
        });

        const existingElement = document
          .getElementById("container")
          .querySelector("div");

        if (existingElement) {
          document
            .getElementById("container")
            .replaceChild(button, existingElement);
          document.getElementsByClassName("gpay-button")[0].click();
        } else {
          document.getElementById("container").appendChild(button);
          document.getElementsByClassName("gpay-button")[0].click();
        }
      });
    },
    async onGooglePaymentButtonClicked() {
      const paymentDataRequest = {
        ...baseRequest,
        allowedPaymentMethods,
        transactionInfo: {
          countryCode: "ES",
          currencyCode: "EUR",
          totalPriceStatus: "FINAL",
          // set to cart total
          totalPrice: parseFloat(this.totalPrice).toString()
        },
        merchantInfo: {
          // A merchant ID is available for a production environment after approval by Google
          // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist}
          merchantId: process.env.VUE_APP_GOOGLEPAY_MERCHANT_ID,
          merchantName: process.env.VUE_APP_GOOGLEPAY_MERCHANT_NAME
        },
        callbackIntents: ["PAYMENT_AUTHORIZATION"]
      };

      paymentsClient
        .loadPaymentData(paymentDataRequest)
        .then(res => {
          console.log("google.pay.loadPaymentData", res);
        })
        .catch(err => {
          console.log("google.pay.loadPaymentData", err);
          this.$router.push({ name: "home" });
        });

      this.dialog = false;
    },
    async onPaymentAuthorized(paymentData) {
      let orderId = randomTransactionId();

      // init payment to check payment success later
      let paymentId = await this.initPayment({
        orders: this.cart,
        paymentMethod: "googlepay",
        amount: parseFloat(this.totalPrice),
        orderAmount: parseFloat(this.totalPrice),
        paymentType: this.dividePayment,
        externalPaymentId: orderId
      });

      return new Promise(resolve => {
        this.processPayment(paymentData, orderId)
          .then(result => {
            if (result.Ds_MerchantParameters) {
              let treatSuccessResult = this.processNotificationParameters(
                result.Ds_MerchantParameters
              );
              console.log("treatSuccessResult::::::", treatSuccessResult);

              if (treatSuccessResult.Ds_Response !== undefined) {
                if (
                  !this.checkCorrectDSResponse(treatSuccessResult.Ds_Response)
                ) {
                  this.showErrorMessage(treatSuccessResult.Ds_Response);
                  return null;
                }
              }

              resolve({ transactionState: "SUCCESS" });
              localStorage.setItem(
                "missingAmountToPay",
                parseFloat(this.unpaidTotalPrice).toFixed(2)
              );
              localStorage.setItem("amountToBePaid", this.totalPrice);
              localStorage.setItem("isPaid", "true");
              if (this.dividePayment === "todo") {
                localStorage.setItem("payment_type", "todo");
              } else if (this.dividePayment === "amount") {
                localStorage.setItem("payment_type", "amount");
              } else {
                localStorage.setItem("payment_type", "product");
              }
              this.$router.push({
                path: "/success-googlepay",
                query: {
                  externalId: treatSuccessResult.Ds_Order,
                  p_id: paymentId
                }
              });
            } else {
              if (result.errorCode !== undefined) {
                // let errorMessage = this.getRedsysErrorMessage(result.errorCode);
                // this.showErrorMessage(errorMessage);
                resolve({
                  transactionState: "ERROR",
                  error: {
                    intent: "PAYMENT_AUTHORIZATION",
                    message: "Error in redsys: " + result.errorCode,
                    reason: result.errorCode
                  }
                });
              } else {
                resolve({
                  transactionState: "ERROR",
                  error: {
                    intent: "PAYMENT_AUTHORIZATION",
                    message: "Something went wrong, try again",
                    reason: "PAYMENT_DATA_INVALID"
                  }
                });
              }
            }
          })
          .catch(err => {
            resolve({
              transactionState: "ERROR",
              error: {
                intent: "PAYMENT_AUTHORIZATION",
                message: "Insufficient funds",
                reason: "PAYMENT_DATA_INVALID"
              }
            });
            this.showErrorMessage("processPayment" + JSON.stringify(err));
            console.error("processPayment", err);
          });
      });
    },
    async processPayment(paymentData, orderId) {
      let paymentToken = paymentData.paymentMethodData.tokenizationData.token;

      // eslint-disable-next-line no-unused-vars,no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        let data = {
          data: {
            DS_MERCHANT_AMOUNT: parseInt(this.totalPrice * 100),
            DS_MERCHANT_CURRENCY: "978",
            DS_MERCHANT_MERCHANTCODE: process.env.VUE_APP_REDSYS_MERCHANT_CODE,
            DS_MERCHANT_ORDER: orderId,
            DS_MERCHANT_TERMINAL: "1",
            DS_MERCHANT_TRANSACTIONTYPE: "0",
            DS_XPAYDATA: btoa(paymentToken),
            DS_XPAYTYPE: "Google",
            DS_XPAYORIGEN: "WEB",
            DS_MERCHANT_DIRECTPAYMENT: "true"
          }
        };

        console.log("Merchant params:::", JSON.stringify(data));

        let result1 = await this.$api.admin.createMerchantParameters(data);

        console.log("googlePayRequest data:::", JSON.stringify(result1));

        let googlePayRequest = {
          data: result1,
          url: process.env.VUE_APP_REDSYS_TREAT_REST_API
        };

        await this.$api.admin
          .sendRedsysRequest(googlePayRequest)
          .then(result => {
            resolve(result);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
